import { useCallback } from 'react';

import { useDispatch, useSelector } from 'app/store';
import {
  settingsShowAnimationSelector,
  settingsShowDeviceNameSelector,
  settingsToggleAnimation,
  settingsToggleDeviceName,
} from 'modules/settings/slice';
import { trackEvent } from 'utils/googleAnalytics';
import DisplayOptionsTile from 'modules/editor/components/Settings/DisplayOptionsTile';

const DisplayOptionsTileContainer = () => {
  const showAnimation = useSelector(settingsShowAnimationSelector);
  const showDeviceName = useSelector(settingsShowDeviceNameSelector);

  const dispatch = useDispatch();

  const onShowDeviceNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(settingsToggleDeviceName());
      trackEvent('settingsChange', { setting: 'showDeviceName', newValue: e.target.checked.toString() });
    },
    [dispatch]
  );
  const onShowAnimationChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(settingsToggleAnimation());
      trackEvent('settingsChange', { setting: 'showAnimation', newValue: e.target.checked.toString() });
    },
    [dispatch]
  );

  return (
    <DisplayOptionsTile
      onShowAnimationChange={onShowAnimationChange}
      onShowDeviceNameChange={onShowDeviceNameChange}
      showAnimation={showAnimation}
      showDeviceName={showDeviceName}
    />
  );
};

export default DisplayOptionsTileContainer;
